{
  "nameInput": {
    "placeholder": "Jina lako ni nani?"
  },
  "signIn": {
    "tagline": "Anza kwa nia.",
    "signingIn": "Inaingia…",
    "continueApple": "Endelea na Apple",
    "continueApple_aria": "Endelea na Apple",
    "continueGoogle": "Endelea na Google",
    "continueGoogle_aria": "Endelea na Google",
    "logo_alt": "Rhemn",
    "footer": "Kwa kuingia, unakubali masharti yetu ya huduma na <privacyLink>Sera ya Faragha</privacyLink>.",
    "divider": "au"
  },
  "email": {
    "identity": {
      "label": "Anwani ya barua pepe",
      "placeholder": "you@example.com",
      "change": "Badilisha",
      "change_aria": "Badilisha anwani ya barua pepe"
    },
    "password": {
      "label": "Nenosiri",
      "labelNew": "Chagua nenosiri",
      "placeholder": "Nenosiri",
      "placeholderNew": "Unda nenosiri",
      "show": "Onyesha nenosiri",
      "hide": "Ficha nenosiri"
    },
    "actions": {
      "continue": "Endelea",
      "signIn": "Ingia",
      "createAccount": "Fungua akaunti",
      "forgot": "Umesahau nenosiri?",
      "backToSignIn": "Rudi kuingia",
      "iVerified": "Nimethibitisha barua pepe yangu",
      "resend": "Tuma kiungo tena",
      "resendIn": "Tuma tena baada ya {{time}}",
      "signInInstead": "Ingia"
    },
    "busy": {
      "checking": "Inakagua…",
      "signingIn": "Inaingia…",
      "creating": "Inaunda akaunti yako…",
      "sending": "Inatuma…"
    },
    "switch": {
      "toCreate": "Mgeni kwenye Rhemn? <switchBtn>Fungua akaunti</switchBtn>",
      "toSignIn": "Tayari una akaunti? <switchBtn>Ingia</switchBtn>"
    },
    "strength": {
      "tooShort": "Angalau herufi 12.",
      "level1": "Vizuri. Refu zaidi ni imara zaidi.",
      "level2": "Nenosiri imara.",
      "level3": "Nenosiri imara sana."
    },
    "sent": {
      "title": "Angalia barua pepe yako",
      "body": "Tumetuma kiungo cha kuweka upya kwa {{email}}. Kinaisha muda baada ya saa moja.",
      "resent": "Kimetumwa tena. Angalia barua pepe yako."
    },
    "verify": {
      "title": "Thibitisha barua pepe yako",
      "body": "Tumetuma kiungo kwa {{email}}. Kifungue ili kukamilisha usanidi wa akaunti yako — tutaendelea kiotomatiki kutoka hapo.",
      "waiting": "Tunasubiri ufungue kiungo…",
      "resent": "Kimetumwa tena. Angalia barua pepe yako."
    },
    "errors": {
      "invalidEmail": "Hiyo haionekani kama anwani ya barua pepe.",
      "missingPassword": "Weka nenosiri lako.",
      "invalidCredential": "Barua pepe au nenosiri si sahihi.",
      "emailInUse": "Barua pepe hiyo tayari ina akaunti. <signInBtn>Ingia badala yake.</signInBtn>",
      "weakPassword": "Tumia angalau herufi 12.",
      "passwordTooShort": "Tumia angalau herufi 12.",
      "passwordCommon": "Nenosiri hilo ni rahisi mno kubahatisha. Jaribu kitu kisichotabirika.",
      "emailNotVerified": "Thibitisha barua pepe yako kabla ya kuendelea.",
      "providerGoogle": "Barua pepe hii tayari imesanidiwa na Google. Endelea na Google hapa chini.",
      "providerApple": "Barua pepe hii tayari imesanidiwa na Apple. Endelea na Apple hapa chini.",
      "userDisabled": "Akaunti hii imezimwa.",
      "requiresRecentLogin": "Ingia tena ili kufanya mabadiliko haya.",
      "sessionExpired": "Kipindi chako kimeisha. Ingia tena.",
      "expiredActionCode": "Kiungo hicho kimeisha muda. Omba kingine.",
      "invalidActionCode": "Kiungo hicho hakifanyi kazi tena. Omba kingine.",
      "tooManyRequests": "Majaribio mengi mno. Subiri dakika chache, au weka upya nenosiri lako.",
      "network": "Hakuna muunganisho. Angalia mtandao wako na ujaribu tena.",
      "operationNotAllowed": "Kuingia kwa barua pepe hakupatikani kwa sasa.",
      "generic": "Hitilafu imetokea. Tafadhali jaribu tena."
    },
    "a11y": {
      "stepEmail": "Hatua ya 1 kati ya 2. Weka anwani yako ya barua pepe.",
      "stepPasswordSignIn": "Hatua ya 2 kati ya 2. Weka nenosiri lako ili kuingia.",
      "stepPasswordCreate": "Hatua ya 2 kati ya 2. Chagua nenosiri kwa akaunti yako mpya.",
      "stepSent": "Kiungo cha kuweka upya kimetumwa. Angalia barua pepe yako.",
      "stepVerify": "Akaunti imeundwa. Kiungo cha uthibitisho kimetumwa.",
      "resendReady": "Sasa unaweza kutuma kiungo tena."
    }
  }
}
